import { getMomentDate } from '../utils/commonUtils';
import { PAGINATION } from '../constants/Define';
import moment from 'moment';
export default class SaleDetailReportBySKU {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.pageIndex = data.pageIndex || PAGINATION.pageIndex;
        this.pageSize = data.pageSize || PAGINATION.pageSize;
        this.totalCount = data.totalCount || 0;
        this.totalPage = Math.ceil(parseInt(data.totalCount || 0) / parseInt(data.pageSize || PAGINATION.pageSize));
        this.startDate = data.startDate ? moment.utc(data.startDate) : moment.utc().startOf('isoWeeks');
        this.endDate = data.startDate ? moment.utc(data.endDate) : moment.utc().endOf('days');
        this.OrderStatus = data.OrderStatus !== undefined ? data.OrderStatus : undefined;
        this.OutletName = data.OutletName || undefined;
        this.orderBy = data.orderBy;
        this.orderByDesc = data.orderByDesc;
        this.items = data.result && data.result.map(item => new SaleReportBySkuItem(item));
    }

}

export class SaleReportBySkuItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined
        this.checkCode = data.checkCode || undefined
        this.checkedBy = data.checkedBy || undefined
        this.checkedDate = data.checkedDate || undefined
        this.couponCode = data.couponCode || undefined
        this.couponValue = data.couponValue || 0
        this.createdDate = data.createdDate || undefined
        this.email = data.email || undefined
        this.fullname = data.fullname || undefined
        this.groupCode = data.groupCode || undefined
        this.id = data.id || undefined
        this.name = data.name || undefined
        this.note = data.note || undefined
        this.operaBookingCode = data.operaBookingCode || undefined
        this.orderCode = data.orderCode || undefined
        this.orderItemType = data.orderItemType || undefined
        this.orderStatus = data.orderStatus || undefined
        this.paymentStatus =  data.paymentStatus || 0
        this.paymentType = data.paymentType || undefined
        this.phoneNumber = data.phoneNumber || undefined
        this.price = data.price || 0
        this.property = data.property || undefined
        this.saleChannel = data.saleChannel || undefined
        this.salePrice = data.salePrice || 0
        this.serialNumber = data.serialNumber || undefined
        this.subTotal = data.subTotal || 0
        this.surcharge = data.surcharge || 0
        this.surchargeDetail = data.surchargeDetail || undefined
        this.totalChangeRateCode = data.totalChangeRateCode || undefined
        this.totalAmount = data.totalAmount || 0
        this.transactionId = data.transactionId || undefined
        this.userEmail = data.userEmail || undefined
        this.voucherStatus = data.voucherStatus || undefined
        this.skuCode = data.skuCode || undefined
        this.skuName = data.skuName || undefined
        this.urlSlug = data.urlSlug || undefined
        this.ticketCode = data.ticketCode || undefined
        this.ticketName = data.ticketName || undefined
        this.ticketType = data.ticketType || undefined
        this.checkInDate = data.checkInDate || undefined
        this.checkOutDate = data.checkOutDate || undefined
        this.endDate = data.endDate || undefined
        this.bookingPeriod = data.bookingPeriod || undefined;
        this.channel = data.channel || undefined;
        this.memberShipCode = data.memberShipCode || undefined;
        this.orderId = data.orderId || undefined;
        this.memberShipName = data.memberShipName || undefined;
        this.groupName = data.groupName || undefined;
        this.totalRounding = data.totalRounding || 0;
        this.departureLocation = data.departureLocation || undefined;
        this.installmentFee = data.installmentFee || undefined;
        this.installmentLimit = data.installmentLimit || undefined;
        this.fullnameCustomer = data.fullnameCustomer || undefined;
        this.emailCustomer = data.emailCustomer || undefined;
        this.phoneNumberCustomer = data.phoneNumberCustomer || undefined;
        this.rateCode = data.rateCode || undefined;
        this.rateName = data.rateName || undefined;
        this.ticketPrice = data.ticketPrice || undefined;
        this.supplierCode = data.supplierCode || undefined;
        this.supplierName = data.supplierName || undefined;
        this.supplierType = data.supplierType || undefined;
        this.supplierProductCode = data.supplierProductCode || undefined;
        this.supplierProductName = data.supplierProductName || undefined;
        this.supplierProductPrice = data.supplierProductPrice || undefined;
        this.sessionInfo = data.sessionInfo || undefined;
        this.agentId = data.agentId || undefined;
        this.affiliateSource = data.affiliateSource || 'original';
    }
}
